<script setup lang="ts">
import type { ParsedFilterData } from '@autobid/strapi-integration/server/trpc/routers/auctions/auctionsFilter'
import type { Ref } from 'vue'
import { useAuctionStore } from '@autobid/nuxt-pinia-store/store/useAuctionStore'
import { Combobox } from '@headlessui/vue'
import { storeToRefs } from 'pinia'
import AuctionButtonsContainer from './AuctionButtonsContainer.vue'
import AuctionListFilterButton from './AuctionListFilterButton.vue'

const auctionStoreKey = inject('auctionStoreKey')
const { filter } = storeToRefs(useAuctionStore(String(auctionStoreKey)))

const filterData = inject('filterData') as Ref<ParsedFilterData>

function toggleAll() {
  filter.value.stage
    = filter.value.stage.length === filterData.value.stages.length
      ? []
      : filterData.value.stages as string[]
}
</script>

<template>
  <Combobox v-model="filter.stage" multiple>
    <AuctionButtonsContainer>
      <AuctionListFilterButton as="button" @click="toggleAll">
        {{ $t('auction-list.all') }}
      </AuctionListFilterButton>
      <AuctionListFilterButton
        v-for="stage in filterData.stages"
        :key="String(stage)"
        :selected="filter.stage.includes(String(stage))"
        :value="stage"
      >
        {{ $t(`auction-list.${String(stage).replace(/_/g, '-').toLowerCase()}`) }}
      </AuctionListFilterButton>
    </AuctionButtonsContainer>
  </Combobox>
</template>
